<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row class="pt-5">
				<div class="w-full md:w-1/4 lg:w-3/12 mb-5 md:mb-0 lg:pr-2">
					<img :src="getUrlOfFile(vars.image, true)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
					<vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3" @click="$refs.file_upload.click()">
						<span class="text-xs">Upload Photo</span>
					</vs-button>
					<input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
						v-on:change="AddPhoto" hidden />
				</div>
				<div class="w-full md:w-3/4 lg:w-9/12 md:px-5">
					<div class="w-full mb-5">
						<vs-input 
								autocomplete="off"
								v-validate="'required'" 
								label="Name" 
								name="name" 
								type="text"
								v-model="models.name" 
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
					</div>

					<vs-row>
						<div class="w-full md:w-1/2 md:pr-2">
							<div class="w-full mb-5">
								<vs-input 
										label="Date Event" 
										name="date" 
										type="date"
										v-model="models.date" 
										class="w-full"/>
								<span class="text-danger text-sm" v-show="errors.has('date')">{{ errors.first('date') }}</span>
							</div>
						</div>
						<div class="w-full md:w-1/2 md:pl-2">
							<div class="w-full mb-5">
								<vs-input 
										autocomplete="off"
										v-validate="'required'" 
										label="Location" 
										name="location" 
										type="text"
										v-model="models.location" 
										class="w-full"/>
								<span class="text-danger text-sm" v-show="errors.has('location')">{{ errors.first('location') }}</span>
							</div>
						</div>
					</vs-row>

					<div class="w-full mb-5">
						<label for="description">Description</label>

						<quill-editor
							v-model="models.description"
						/>
					</div>

					<label for="assign_to">Assign To</label>
					<vs-row class="mt-1">
						<div class="w-full md:w-1/3 md:pr-2">
							<select class="w-full" v-model="models.type">
								<option v-for="(type, index) in masters.types" :key="index" :value="type.value">{{type.text}}</option>
							</select>
							<input type="hidden" v-validate="'required'" 
										name="assign to" v-model="models.type">
							<span class="text-danger text-sm" v-show="errors.has('assign to')">{{ errors.first('assign to') }}</span>

						</div>
						<div class="w-full md:w-1/3 md:px-2 mt-3 md:mt-0" v-if="models.type">
							<v-select
								v-if="models.type === 'tiers'"
								v-model="vars.tierIds"
								multiple
								:reduce="tier => tier.id" 
								:options="masters.tiers"
								label="name"
							/>
							<v-select
								v-else-if="models.type === 'users'"
								v-model="vars.userIds"
								multiple
								:reduce="user => user.id" 
								:options="masters.ambassadors"
								label="name"
							/>
						</div>
					</vs-row>

					<div class="w-full my-5">
						<label class="pl-1 text-sm" for="status">Status</label>
						<ul id="status" class="flex mt-2">
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="true" class="mr-5">Active</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="false">Inactive</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
					</div>
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	import moment from 'moment'
	import api from '@/utils/api.js'
	import {
		getUrlOfFile,
		uploadFile
	} from '@/utils/helpers.js';

	export default {
		name: 'FormUser',
		data() {
			return {
				getUrlOfFile,
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: "",
					image: "",
					location: "",
					date: "",
					description: "",
					type: null,
					tierIds: [],
					userIds: [],
					isActive: true
				},
				masters: {
					types: [
						{
							value: null,
							text: 'Select type'
						},
						{
							value: 'all',
							text: 'All Users'
						},
						{
							value: 'tiers',
							text: 'Tiers'
						},
						{
							value: 'users',
							text: 'Users'
						},
					],
					ambassadors: [],
					tiers: []
				},
				vars: {
					image: '',
					tierIds: [],
					userIds: []
				}
			}
		},
		computed: { 
			arrayChange(){
				return this.models.type
			}
		},
		created() {
			Promise.all([
				this.getById(),
				this.getOptions()
			]).then(() => {
				this.$watch('arrayChange', () => {
					this.models.tierIds = []
					this.models.userIds = []
				})
			})
		},
		methods: {
			getById() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.events}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.name = data.name
							this.vars.image = data.image
							this.models.date = moment(data.createdAt).format('YYYY-MM-DD')
							this.models.location = data.location
							this.models.description = data.description
							this.models.type = data.type
							this.models.isActive = data.isActive
							this.vars.tierIds = data.eventTiers.map(tier => tier.id)
							this.vars.userIds = data.eventUsers.map(user => user.id)
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},
			getOptions() {
				const tiers = this.$axios.get(api.mics_tiers)
				const ambassadors = this.$axios.get(api.misc_ambassadors)

				Promise.all([tiers, ambassadors])
					.then(res => {
						this.masters.tiers = [...res[0].data.data]
						this.masters.ambassadors = [...res[1].data.data]
					})
			},
			AddPhoto(event) {
				let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
				if(event.target.files[0].size < fileSizeLimit) {
					this.vars.image = event.target.files[0];
				} else {
					this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
				}
			},
			save() {
				this.$validator.validate().then(async valid => {
					if (valid) {
						let request = "";
						let message = "create"

						this.models.image = typeof this.vars.image === 'string' ? this.vars.image : await uploadFile(this.vars.image)
						this.models.tierIds = [...this.vars.tierIds]
						this.models.userIds = [...this.vars.userIds]

						if (!this.$route.params.id) {
							request = this.$axios.post(api.events, this.models);
						} else {
							message = "update"
							request = this.$axios.put(`${api.events}/${this.$route.params.id}`, this.models);
						}
						request
							.then(() => {
								this.$showToast('Success', `Success ${message} admin`,)
								this.$router.push({
									name: this.config.uri
								})
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>